module.exports = __webpack_public_path__ + "7d088296/img/send-icon.3cfb6275.svg";